import { GET_TENANT_STATISTICS_SUCCESS, CLEAR_TENANT_STATISTICS_SUCCESS } from './constants';

let tenantStatisticsState = {};

/**
 *
 * @param state
 * @param action
 * @returns {{error: boolean, status: string}}
 */
const tenantStatistics = ( state = tenantStatisticsState, action ) => {
    switch ( action.type ) {
        case CLEAR_TENANT_STATISTICS_SUCCESS: {
            state = {};
            return state;
        }
        case  GET_TENANT_STATISTICS_SUCCESS : {
            return { ...action.result };
        }

        default:
            return state;
    }
};

export { tenantStatistics };